import axioApi, { setHeader } from 'api/root.api';

export const loginGet = async (token)=>{
    const urlEnd = '/platform/account/v1/account';
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
};